import client from "./client";
import { toastError } from "../toastHelper";

const BASE_PATH = "/resale_listings";

const extractErrors = (error) => {
  const data = error?.response?.data;
  if (data?.errors?.length) {
    return data.errors.join(", ");
  }
  return "Something went wrong. Please try again.";
};

export const createListing = async ({ orderId, ticketIds, listPriceCents, sellerAttestationVersion }) => {
  try {
    const body = {
      order_id: orderId,
      resale_listing_items_attributes: ticketIds.map((id) => ({ ticket_id: id })),
      seller_attestation_version: sellerAttestationVersion,
    };
    if (listPriceCents !== undefined && listPriceCents !== null) {
      body.list_price_cents = listPriceCents;
    }
    const { data } = await client.post(BASE_PATH, {
      resale_listing: body,
    });
    return data.resale_listing || data;
  } catch (error) {
    toastError(extractErrors(error));
    throw error;
  }
};

export const updateListingPrice = async ({ id, listPriceCents }) => {
  try {
    const { data } = await client.patch(`${BASE_PATH}/${id}.json`, {
      resale_listing: { list_price_cents: listPriceCents },
    });
    return data.resale_listing || data;
  } catch (error) {
    toastError(extractErrors(error));
    throw error;
  }
};

export const delistListing = async ({ id }) => {
  try {
    const { data } = await client.delete(`${BASE_PATH}/${id}.json`);
    return data.resale_listing || data;
  } catch (error) {
    toastError(extractErrors(error));
    throw error;
  }
};

export const fetchMyListings = async () => {
  try {
    const { data } = await client.get(`${BASE_PATH}.json`);
    return data.resale_listings || data;
  } catch (error) {
    toastError(extractErrors(error));
    throw error;
  }
};
